/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Socials_Zalo_Oa_Id1Inputs */

const vi_sitesettings_socials_zalo_oa_id1 = /** @type {(inputs: Sitesettings_Socials_Zalo_Oa_Id1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zalo OA ID`)
};

/**

* @param {Sitesettings_Socials_Zalo_Oa_Id1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_socials_zalo_oa_id1 = /** @type {((inputs?: Sitesettings_Socials_Zalo_Oa_Id1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Socials_Zalo_Oa_Id1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_socials_zalo_oa_id1(inputs)
});
export { sitesettings_socials_zalo_oa_id1 as "siteSettings_socials_zalo_oa_id" }